export const BASE_URL = process.env.VUE_APP_BASE_URL
// thumbUrl
export const DEFAULT_THUMB_URL = 'http://cdn.airfunc.com/990028376e3f4fa59426cccd1c5bd9b5'
// 游记标签ID
export const TRAVEL_TAG_ID = 'cb33c1c4-4dda-416a-8775-2b64b01f0065'
// 主题列表
export const THEME_LIST = ['light', 'dark']


// 默认分页数
export const DEFAULT_LIMIT = 20

// 留言的默认id
export const MESSAGE_BOARD_HOST_ID = 'MESSAGE-BOARD-HOST-ID'


// 链接
export const HEADER_LINKS = [
    {
        "name": "首页",
        "slug": "home",
        "type": "static",
        icon: 'icon-homepage'
        // "routeName": "section-slug"
    },
    {
        "name": "游记",
        "slug": "photoWall",
        "type": "static",
        icon: 'icon-xiangce'
        // "routeName": "section-slug"
    },
    {
        "name": "时间轴",
        "slug": "timeline",
        "type": "static",
        icon: 'icon-other'
        // "routeName": "section-slug"
    },
    {
        "name": "留言板",
        "slug": "messageBoard",
        "type": "static",
        icon: 'icon-mail'
        // "routeName": "section-slug"
    },
    {
        "name": "关于",
        "slug": "about",
        "type": "static",
        icon: 'icon-headlines'

    },
]